import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";

const inputCls = "bg-cream border-olive/40 focus-visible:ring-burgundy text-charcoal";

export const BlogFormDialog = ({ open, onOpenChange, form, setForm, editing, saving, onSave }) => {
  const update = (field) => (e) => setForm({ ...form, [field]: e.target.value });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="blog-edit-dialog" className="bg-cream border-olive/40 max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-display text-charcoal text-2xl">
            {editing ? "Edit Post" : "New Post"}
          </DialogTitle>
          <DialogDescription className="text-charcoal/60 font-body">
            Write and manage a journal article for your site.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 mt-2">
          <div>
            <Label className="text-charcoal/70">Title</Label>
            <Input data-testid="blog-title-input" className={inputCls} value={form.title} onChange={update("title")} />
          </div>
          <div>
            <Label className="text-charcoal/70">Excerpt</Label>
            <Textarea data-testid="blog-excerpt-input" className={inputCls} value={form.excerpt} onChange={update("excerpt")} />
          </div>
          <div>
            <Label className="text-charcoal/70">Content</Label>
            <Textarea data-testid="blog-content-input" className={`${inputCls} min-h-[140px]`} value={form.content} onChange={update("content")} />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label className="text-charcoal/70">Category</Label>
              <Input data-testid="blog-category-input" className={inputCls} value={form.category} onChange={update("category")} />
            </div>
            <div className="flex items-end gap-3 pb-2">
              <Switch data-testid="blog-published-switch" checked={form.published} onCheckedChange={(v) => setForm({ ...form, published: v })} />
              <Label className="text-charcoal/70">Published</Label>
            </div>
          </div>
          <div>
            <Label className="text-charcoal/70">Image URL</Label>
            <Input data-testid="blog-image-input" className={inputCls} value={form.image_url} onChange={update("image_url")} />
          </div>
        </div>
        <DialogFooter className="mt-4">
          <Button variant="outline" className="rounded-none border-charcoal/40 text-charcoal" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button data-testid="save-blog-button" disabled={saving} className="bg-maroon hover:bg-burgundy text-cream rounded-none" onClick={onSave}>
            {saving ? "Saving…" : "Save Post"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
